import { DomainBase } from "./DomainBase";
export class UserRole extends DomainBase {
    constructor() {
        super();
        this.Name = '';
        this.Active = false;
        this.Level = 0;
       
    }
}